import { DEFAULT_AGENT_STYLE } from "@web-src/modules/cx/pages/CXAIAgentsPage/consts";

export const TONE_VALUES = ["business", "neutral", "creative"] as const;
export const EMOJI_USAGE_VALUES = ["none", "average", "many"] as const;

export const getDiscreteIndex = (value: number): number => {
  const index = Math.round(value / (10 / (TONE_VALUES.length - 1)));
  if (index < 0) return 0;
  if (index > 2) return 2;
  return index;
};

export const getDiscreteValueByIndex = (index: number): number =>
  Math.round((index * 10) / (TONE_VALUES.length - 1));

export const getDiscreteIndexByValue = (
  value: string,
  values: readonly string[]
) => {
  const index = values.indexOf(value);
  return index === -1 ? 1 : index;
};

const isToneValue = (value: string): value is (typeof TONE_VALUES)[number] =>
  TONE_VALUES.includes(value as (typeof TONE_VALUES)[number]);

const isEmojiUsageValue = (
  value: string
): value is (typeof EMOJI_USAGE_VALUES)[number] =>
  EMOJI_USAGE_VALUES.includes(value as (typeof EMOJI_USAGE_VALUES)[number]);

export const getSanitizedStyleConfig = <
  T extends {
    tone: string;
    emoji_usage: string;
    response_length: number;
  }
>(
  config: T
) => {
  const sanitizedTone: (typeof TONE_VALUES)[number] = isToneValue(config.tone)
    ? config.tone
    : DEFAULT_AGENT_STYLE.tone;
  const sanitizedEmojiUsage: (typeof EMOJI_USAGE_VALUES)[number] =
    isEmojiUsageValue(config.emoji_usage)
      ? config.emoji_usage
      : DEFAULT_AGENT_STYLE.emoji_usage;
  const sanitizedResponseLength =
    Number.isInteger(config.response_length) &&
    config.response_length >= 0 &&
    config.response_length <= 10
      ? config.response_length
      : DEFAULT_AGENT_STYLE.response_length;

  return {
    ...config,
    tone: sanitizedTone,
    emoji_usage: sanitizedEmojiUsage,
    response_length: sanitizedResponseLength,
  };
};
